import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from '../auth/msalConfig'
import App from './App.jsx'
import './index.css'

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

const renderApp = () => {
  root.render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>
  )
}

msalInstance
  .initialize()
  .then(renderApp)
  .catch((error) => {
    root.render(
      <StrictMode>
        <div>Failed to initialize authentication: {String(error?.message || error)}</div>
      </StrictMode>
    )
  })
